import { render, staticRenderFns } from "./GeologyLeft.vue?vue&type=template&id=2bce8440&scoped=true&"
import script from "./GeologyLeft.vue?vue&type=script&lang=js&"
export * from "./GeologyLeft.vue?vue&type=script&lang=js&"
import style0 from "./GeologyLeft.vue?vue&type=style&index=0&id=2bce8440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce8440",
  null
  
)

export default component.exports